import PatientChip from './PatientChip';
export default PatientChip;
